module.exports = __webpack_public_path__ + "img/logo_new.4cf4ccc9.png";